module.exports = __webpack_public_path__ + "img/avatar6.53193e53.png";